export type AdmissionType = {
  id: string;
  name: string;
  disabled?: boolean;
};

export const ADMISSIONS: AdmissionType[] = [
  {
    id: 'IOWA',
    name: 'Initial offer without admission to trading on a regulated market',
  },
  {
    id: 'IORM',
    name: 'Initial offer with admission to trading on a regulated market',
  },
  {
    id: 'SOWA',
    name: 'Secondary offer without admission to trading on a regulated market',
  },
  {
    id: 'IRMT',
    name: 'Initial admission to trading on regulated market',
  },
  {
    id: 'IPTM',
    name: 'Initial admission to trading on regulated market from previously being traded on MTF',
  },
  {
    id: 'IMTF',
    name: 'Initial admission to trading on MTF with offer to the public',
  },
  {
    id: 'SOOA',
    name: 'Secondary offer with admission to trading on a regulated market',
  },
  {
    id: 'SIWO',
    name: 'Secondary issuance on a regulated market without an offer to the public',
  },
  {
    id: 'SIOP',
    name: 'Secondary issuance on an MTF with an offering to the public',
  },
];
